import { msalInstance } from '@/auth/mintAuthenticationProvider'
import { microsoftAuthConfiguration } from '@/auth/mintAuthConfiguration'
import { getStoredAccessToken, isTestMode } from '@/testMode'
import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser'
import { clearCacheAndReload, isTokenExpirationError } from '@/auth/logout'

const getMsalToken = async () => {
  const instance = await msalInstance()
  const authenticationParameters = await microsoftAuthConfiguration()
  const account = instance.getAllAccounts().filter(account => account.tenantId === authenticationParameters.tenantId)[0]

  if (!account) {
    await instance.loginRedirect(authenticationParameters)
    return
  }

  const tokenRequest = {
    account: account,
    scopes: authenticationParameters.scopes,
  }
  try {
    const tokenResponse = await instance.acquireTokenSilent(tokenRequest)
    return tokenResponse.accessToken
  } catch (error: any) {
    if (error instanceof InteractionRequiredAuthError) {
      await instance.loginRedirect(authenticationParameters)
    } else if (error instanceof BrowserAuthError) {
      console.error('BrowserAuthError when trying to acquire token, clearing storage', error)
      await clearCacheAndReload(instance)
    } else if (isTokenExpirationError(
      error?.code || error?.error || error?.errorCode,
      error?.errorMessage || error?.error_description || error?.message || JSON.stringify(error)
    )) {
      console.error('Token expiration error detected, clearing cache and reloading', error)
      await clearCacheAndReload(instance)
    } else {
      console.error('Unhandled error when trying to acquire token:', error)
    }
  }
}

export const accessToken = async () => {
  return isTestMode() ? getStoredAccessToken() : getMsalToken()
}
